import React from 'react';
import { HomeBanner } from '../../components/home/homeBanner';
import { CategoryAuctionsNew } from './components/CatergoryAuctions';
import PartnersSection from './pages/Landing/components/OurPartners';
import AppDownloadSection from './pages/Landing/components/AppDownloadSection';
import Statistics from './pages/Landing/components/Statistics';
import PartnersSectionNew from './pages/RealEstate/components/OurPartner';
import FaqSection from './pages/Landing/components/Faq';
import AuctionSwitcher from './pages/RealEstate/components/AuctionSwitcher';

export class Homepage extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        <HomeBanner callbackForSupport={this.props.callbackForSupport} />
        {/* <CategorySearch /> */}
        <AuctionSwitcher />

        {/* <CategoryAuctionsNew /> */}
        {/* <BeingPart /> */}
        <FaqSection />
        <Statistics />
        <PartnersSectionNew />
        {/* <PartnersSection /> */}
        
        <AppDownloadSection />
      </div>
    );
  }
}
